"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "flex justify-end" };
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-plus" }, null, -1);
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = {
    key: 0,
    class: "marso-icon-right text-green"
};
const _hoisted_9 = {
    key: 1,
    class: "marso-icon-wrong text-red"
};
const _hoisted_10 = {
    key: 0,
    class: "marso-icon-right text-green"
};
const _hoisted_11 = {
    key: 1,
    class: "marso-icon-wrong text-red"
};
const _hoisted_12 = {
    key: 0,
    class: "marso-icon-right text-green"
};
const _hoisted_13 = {
    key: 1,
    class: "marso-icon-wrong text-red"
};
const _hoisted_14 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_15 = ["onClick"];
const _hoisted_16 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-pencil" }, null, -1);
const _hoisted_17 = ["onClick"];
const _hoisted_18 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-trash" }, null, -1);
const _hoisted_19 = { class: "flex flex-col md:flex-row" };
const _hoisted_20 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_21 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_22 = { class: "flex flex-col md:flex-row pb-3" };
const _hoisted_23 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_24 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_25 = { class: "py-4 border-t-1 border-gray" };
const _hoisted_26 = { class: "mb-2" };
const _hoisted_27 = { class: "uppercase text-sm font-bold" };
const _hoisted_28 = { class: "text-xs" };
const _hoisted_29 = { class: "py-4 border-t-1 border-b-1 border-gray" };
const _hoisted_30 = { class: "mb-2" };
const _hoisted_31 = { class: "uppercase text-sm font-bold" };
const _hoisted_32 = { class: "text-xs" };
const _hoisted_33 = { class: "flex items-center my-5 gap-4" };
const _hoisted_34 = { key: 1 };
const _hoisted_35 = { class: "flex flex-wrap" };
const _hoisted_36 = { class: "w-full" };
const _hoisted_37 = { class: "flex list-none flex-wrap pt-3 pb-4 flex-row" };
const _hoisted_38 = {
    key: 0,
    class: "mr-2 last:mr-0 flex-auto text-center bg-gray cursor-pointer"
};
const _hoisted_39 = {
    key: 1,
    class: "mr-2 last:mr-0 flex-auto text-center bg-gray cursor-pointer"
};
const _hoisted_40 = {
    key: 2,
    class: "mr-2 last:mr-0 flex-auto text-center bg-gray cursor-pointer"
};
const _hoisted_41 = { class: "relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded" };
const _hoisted_42 = { class: "flex-auto" };
const _hoisted_43 = { class: "tab-content tab-space" };
const _hoisted_44 = {
    key: 0,
    class: "text-red font-bold"
};
const _hoisted_45 = { key: 0 };
const _hoisted_46 = { class: "flex flex-col md:flex-row gap-4 py-4 border-b-1 border-gray flex justify-end" };
const _hoisted_47 = ["src"];
const _hoisted_48 = ["onClick"];
const _hoisted_49 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const _hoisted_50 = {
    key: 1,
    class: "text-red font-bold"
};
const _hoisted_51 = { key: 0 };
const _hoisted_52 = { class: "flex flex-col md:flex-row gap-4 py-4 border-b-1 border-gray flex justify-end" };
const _hoisted_53 = ["src"];
const _hoisted_54 = ["onClick"];
const _hoisted_55 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const _hoisted_56 = { class: "flex items-center md:w-5/6" };
const _hoisted_57 = { class: "font-bold uppercase" };
const _hoisted_58 = { class: "grid grid-cols-3 gap-4 border-t-1 border-b-1 border-gray py-4" };
const _hoisted_59 = {
    key: 0,
    class: "text-red font-bold"
};
const _hoisted_60 = { key: 0 };
const _hoisted_61 = { class: "flex flex-col md:flex-row gap-4 py-4 border-b-1 border-gray flex justify-end" };
const _hoisted_62 = ["src"];
const _hoisted_63 = ["onClick"];
const _hoisted_64 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const _hoisted_65 = {
    key: 1,
    class: "text-red font-bold"
};
const _hoisted_66 = { key: 0 };
const _hoisted_67 = { class: "flex flex-col md:flex-row gap-4 py-4 border-b-1 border-gray flex justify-end" };
const _hoisted_68 = ["src"];
const _hoisted_69 = ["onClick"];
const _hoisted_70 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const _hoisted_71 = {
    key: 0,
    class: "text-red font-bold"
};
const _hoisted_72 = { key: 0 };
const _hoisted_73 = { class: "flex flex-col md:flex-row gap-4 py-4 border-b-1 border-gray flex justify-end" };
const _hoisted_74 = ["src"];
const _hoisted_75 = ["onClick"];
const _hoisted_76 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const _hoisted_77 = { class: "flex flex-col md:flex-row gap-4 pt-4 border-t-1 border-gray flex justify-end" };
const _hoisted_78 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const vue_3 = require("vue");
const Form_1 = require("../../components/Form");
const toastStore_1 = require("../../stores/toast/toastStore");
const i18n_1 = require("../../common/i18n");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const SelectInput_vue_1 = __importDefault(require("../../components/Form/Select/SelectInput.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const Alert_vue_1 = __importDefault(require("../../components/Alert.vue"));
const bannerStore_1 = require("../../stores/banner/bannerStore");
const BannerFile_1 = require("../../stores/banner/BannerFile");
const BannerRequest_1 = require("../../stores/banner/BannerRequest");
const vue_router_1 = require("vue-router");
const shop_1 = require("../../common/utils/shop");
const securityStore_1 = require("../../stores/security/securityStore");
const Option_1 = __importDefault(require("../../components/Form/Select/Option"));
const BannerStatusEnum_1 = require("../../stores/banner/BannerStatusEnum");
const banner_search_pages_1 = require("../../stores/banner/banner-search-pages");
const SkuTagSearchInput_vue_1 = __importDefault(require("../../components/ProductSearch/SkuTagSearchInput.vue"));
const ShopConfig_1 = require("../../common/utils/ShopConfig");
const SearchInputOption_1 = __importDefault(require("../../components/Form/SearchInput/SearchInputOption"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AdminBanners',
    props: {
        bannerFileType: String
    },
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const props = __props;
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const bannerStore = (0, bannerStore_1.useBannerStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3MB
        const dimensionRequirements = {
            [BannerFile_1.BannerFileTypeEnum.MAIN_PAGE]: { w: 980, h: 120 },
            [BannerFile_1.BannerFileTypeEnum.SEARCH_PAGE]: { w: 980, h: 120 },
            [BannerFile_1.BannerFileTypeEnum.MAIN_PAGE_MOBILE]: { w: 336, h: 280 },
            [BannerFile_1.BannerFileTypeEnum.SEARCH_PAGE_MOBILE]: { w: 336, h: 280 },
            [BannerFile_1.BannerFileTypeEnum.UNIVERSAL]: { w: 336, h: 280 },
        };
        const modalIsOpen = (0, vue_3.ref)(false);
        const errorMessage = (0, vue_3.ref)("");
        const fileErrorMessage = (0, vue_3.ref)("");
        const lastUploadType = (0, vue_3.ref)(null);
        const bannerRequest = (0, vue_3.ref)(new BannerRequest_1.BannerRequest());
        const selectedBanner = (0, vue_3.ref)(null);
        const sortBy = (0, vue_3.ref)("id");
        const sortDesc = (0, vue_3.ref)(false);
        const page = (0, vue_3.ref)(1);
        const itemsPerPage = (0, vue_3.ref)(20);
        const openTab = (0, vue_3.ref)("");
        const searchPages = {};
        const customerGroupOptions = (0, vue_3.ref)((_a = ShopConfig_1.ShopConfig.getCustomerGroups().map(group => new SearchInputOption_1.default(group, group))) !== null && _a !== void 0 ? _a : []);
        const departmentOptions = (0, vue_3.ref)((_b = ShopConfig_1.ShopConfig.getDepartments().map(dept => new SearchInputOption_1.default(dept, dept))) !== null && _b !== void 0 ? _b : []);
        const uploadedFile = (0, vue_3.ref)(null);
        const bannerStatusOptions = (0, vue_3.ref)([
            new Option_1.default(BannerStatusEnum_1.BannerStatusEnum.DRAFT, (_c = (0, i18n_1.trans)("draft", "Draft", "banners")) !== null && _c !== void 0 ? _c : "Draft", false),
            new Option_1.default(BannerStatusEnum_1.BannerStatusEnum.WAITING, (_d = (0, i18n_1.trans)("waiting", "Waiting", "banners")) !== null && _d !== void 0 ? _d : "Waiting", false),
            new Option_1.default(BannerStatusEnum_1.BannerStatusEnum.ACTIVE, (_e = (0, i18n_1.trans)("active", "Active", "banners")) !== null && _e !== void 0 ? _e : "Active", false),
            new Option_1.default(BannerStatusEnum_1.BannerStatusEnum.EXPIRED, (_f = (0, i18n_1.trans)("expired", "Expired", "banners")) !== null && _f !== void 0 ? _f : "Expired", false),
        ]);
        const selectedBannerFiles = (0, vue_3.computed)(() => bannerStore.bannerFiles);
        const listFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_g = (0, i18n_1.trans)("id", "ID", "banners")) !== null && _g !== void 0 ? _g : "ID",
                value: "id",
                sortable: true,
                filterable: true,
            },
            {
                key: "title",
                label: (_h = (0, i18n_1.trans)("title", "title", "banners")) !== null && _h !== void 0 ? _h : "title",
                value: "title",
                filterable: true,
                sortable: true,
            },
            {
                key: "status",
                label: (_j = (0, i18n_1.trans)("status", "status", "banners")) !== null && _j !== void 0 ? _j : "status",
                value: "status",
                filterable: true,
                sortable: true,
            },
            {
                key: "createdDatetime",
                label: (_k = (0, i18n_1.trans)("createdDatetime", "Created date", "banners")) !== null && _k !== void 0 ? _k : "Created date",
                value: "createdDatetime",
                sortable: true,
                filterable: true,
            },
            {
                key: "datePublish",
                label: (_l = (0, i18n_1.trans)("datePublish", "Publish date", "banners")) !== null && _l !== void 0 ? _l : "Last time logged",
                value: "datePublish",
                sortable: true,
                filterable: true,
            },
            {
                key: "dateDePublish",
                label: (_m = (0, i18n_1.trans)("dateDePublish", "Publish de date", "banners")) !== null && _m !== void 0 ? _m : "Last time logged",
                value: "dateDePublish",
                sortable: true,
                filterable: true,
            },
            {
                key: "displayMainPageBanner",
                label: (0, i18n_1.trans)("displayMainPageBanner", "Main", "banners"),
                value: "displayMainPageBanner",
            },
            {
                key: "displaySearchPageBanner",
                label: (0, i18n_1.trans)("displaySearchPageBanner", "Search", "banners"),
                value: "displaySearchPageBanner",
            },
            {
                key: "displayUniversalBanner",
                label: (0, i18n_1.trans)("displayUniversalBanner", "Universal", "banners"),
                value: "displayUniversalBanner",
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const bannerQuery = (0, vue_3.computed)(() => {
            const filters = {};
            listFields.value.forEach((field) => {
                if (field.filterable && field.filterValue) {
                    filters[field.key] = field.filterValue;
                }
            });
            let order = `order[${sortBy.value}]`;
            return {
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                [order]: sortDesc.value ? "desc" : "asc",
                ...filters,
            };
        });
        (0, vue_3.onBeforeUnmount)(() => {
            bannerStore.reset();
        });
        (0, vue_3.onBeforeMount)(async () => {
            bannerStore.reset();
            try {
                await bannerStore.getBanners(router, bannerQuery.value);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
            banner_search_pages_1.SEARCH_BANNER_PAGES.forEach(function (value) {
                searchPages[`${value}`] = (0, vue_3.ref)(false);
            });
        });
        (0, vue_3.watch)(bannerQuery, async () => {
            try {
                await bannerStore.getBanners(router, bannerQuery.value);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        });
        const openCreateBannerModal = () => {
            bannerRequest.value = new BannerRequest_1.BannerRequest();
            selectedBanner.value = null;
            bannerStatusOptions.value.forEach((option) => {
                option.selected = false;
            });
            modalIsOpen.value = true;
            bannerStore.resetBannerFiles();
        };
        const toggleTabs = (tabName) => {
            openTab.value = tabName;
        };
        const checkActiveTab = () => {
            if (selectedBanner.value.displayMainPageBanner) {
                openTab.value = BannerFile_1.BannerFileTypeEnum.MAIN_PAGE;
                return true;
            }
            else if (selectedBanner.value.displaySearchPageBanner) {
                openTab.value = BannerFile_1.BannerFileTypeEnum.SEARCH_PAGE;
                return true;
            }
            else if (selectedBanner.value.displayUniversalBanner) {
                openTab.value = BannerFile_1.BannerFileTypeEnum.UNIVERSAL;
                return true;
            }
        };
        const openUpdateBannerModal = async (banner) => {
            var _a;
            selectedBanner.value = banner;
            openTab.value = "";
            (_a = selectedBanner.value) === null || _a === void 0 ? void 0 : _a.searchPageBannerFilter.forEach(function (value) {
                searchPages[`${value}`].value = true;
            });
            bannerRequest.value = new BannerRequest_1.BannerRequest(selectedBanner.value.createdUser, selectedBanner.value.createdDatetime, selectedBanner.value.title, selectedBanner.value.status, selectedBanner.value.datePublish ? (0, shop_1.formatDate)(new Date(selectedBanner.value.datePublish)) : null, selectedBanner.value.dateDePublish ? (0, shop_1.formatDate)(new Date(selectedBanner.value.dateDePublish)) : null, selectedBanner.value.mainPageUrl, selectedBanner.value.searchPageUrl, selectedBanner.value.universalUrl, selectedBanner.value.displayMainPageBanner, selectedBanner.value.displaySearchPageBanner, selectedBanner.value.displayUniversalBanner, selectedBanner.value.searchPageBannerFilter, selectedBanner.value.customerGroups, selectedBanner.value.departments);
            bannerStatusOptions.value.forEach((option) => {
                var _a;
                option.selected = option.value === ((_a = selectedBanner.value) === null || _a === void 0 ? void 0 : _a.status);
            });
            checkActiveTab();
            bannerStore.resetBannerFiles();
            try {
                await bannerStore.getBannerFiles(router, { pagination: false, banner: selectedBanner.value.id });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
            modalIsOpen.value = true;
        };
        const deleteBanner = async (banner) => {
            if (!confirm((0, i18n_1.trans)("delete_banner_confirm", "Are you sure?", "banners"))) {
                return;
            }
            errorMessage.value = "";
            try {
                await bannerStore.deleteBanner(router, banner.id);
                bannerStore.reset();
                await bannerStore.getBanners(router, bannerQuery.value);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const createBanner = async () => {
            errorMessage.value = "";
            bannerRequest.value.createdDatetime = new Date();
            bannerRequest.value.status = BannerStatusEnum_1.BannerStatusEnum.DRAFT;
            bannerRequest.value.createdUser = securityStore.authenticatedUser.iri;
            Object.keys(searchPages).forEach((key) => {
                if (searchPages[key].value) {
                    bannerRequest.value.searchPageBannerFilter.push(key);
                }
            });
            try {
                const response = await bannerStore.createBanner(router, bannerRequest.value);
                bannerStore.reset();
                page.value = 1;
                selectedBanner.value = bannerRequest.value;
                selectedBanner.value.id = response.id;
                await bannerStore.getBanners(router, bannerQuery.value);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const updateBanner = async () => {
            var _a;
            errorMessage.value = "";
            if (selectedBanner.value === null) {
                errorMessage.value =
                    (_a = (0, i18n_1.trans)("banner_not_selected", "Banner not selected", "banners")) !== null && _a !== void 0 ? _a : "Banner not selected";
                return;
            }
            if (bannerRequest.value.datePublish == "") {
                bannerRequest.value.datePublish = null;
            }
            if (bannerRequest.value.dateDePublish == "") {
                bannerRequest.value.dateDePublish = null;
            }
            banner_search_pages_1.SEARCH_BANNER_PAGES.forEach(function (value) {
                let checked = bannerRequest.value.searchPageBannerFilter.indexOf(value);
                if (searchPages[value].value && checked < 0) {
                    bannerRequest.value.searchPageBannerFilter.push(value);
                }
                else if (!searchPages[value].value && checked >= 0) {
                    bannerRequest.value.searchPageBannerFilter.splice(checked, 1);
                }
            });
            try {
                await bannerStore.updateBanner(router, bannerRequest.value, selectedBanner.value.id);
                modalIsOpen.value = false;
                bannerStore.reset();
                page.value = 1;
                await bannerStore.getBanners(router, bannerQuery.value);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        (0, vue_3.watch)(modalIsOpen, (value) => {
            if (!value) {
                errorMessage.value = "";
                fileErrorMessage.value = "";
                Object.keys(searchPages).forEach((key) => {
                    searchPages[key].value = false;
                });
            }
        });
        const saveBannerFile = async (type) => {
            var _a, _b, _c, _d, _e;
            lastUploadType.value = type;
            errorMessage.value = "";
            fileErrorMessage.value = "";
            if (uploadedFile.value === null) {
                fileErrorMessage.value = (_a = (0, i18n_1.trans)('file_not_browsed', 'No file selected', 'banners')) !== null && _a !== void 0 ? _a : 'No file selected';
                return;
            }
            if (selectedBanner.value === null) {
                fileErrorMessage.value = (_b = (0, i18n_1.trans)('banner_not_selected', 'Banner not selected', 'banners')) !== null && _b !== void 0 ? _b : 'Banner not selected';
                return;
            }
            const allowedMimeTypes = ["image/png", "image/jpeg"]; // jpeg és jpg ugyanaz
            if (!allowedMimeTypes.includes(uploadedFile.value.type)) {
                fileErrorMessage.value = (_c = (0, i18n_1.trans)('invalid_file_type', 'Invalid file type (only PNG/JPG)', 'banners')) !== null && _c !== void 0 ? _c : 'Invalid file type (only PNG/JPG)';
                return;
            }
            if (uploadedFile.value.size > MAX_FILE_SIZE) {
                fileErrorMessage.value = (_d = (0, i18n_1.trans)('file_too_large', 'File too large (max 3MB)', 'banners')) !== null && _d !== void 0 ? _d : 'File too large (max 3MB)';
                return;
            }
            const req = dimensionRequirements[type];
            if (req) {
                const valid = await checkImageDimensions(uploadedFile.value, req.w, req.h);
                if (!valid) {
                    fileErrorMessage.value = (_e = (0, i18n_1.trans)('invalid_dimensions', `Invalid dimensions. Required ${req.w}x${req.h}`, 'banners')) !== null && _e !== void 0 ? _e : `Invalid dimensions. Required ${req.w}x${req.h}`;
                    return;
                }
            }
            const formData = new FormData();
            formData.append("file", uploadedFile.value);
            formData.append("bannerId", String(selectedBanner.value.id));
            formData.append("type", type);
            try {
                await bannerStore.saveBannerFile(router, formData);
                if (selectedBanner.value === null)
                    return;
                uploadedFile.value = null;
                fileErrorMessage.value = "";
                await bannerStore.getBannerFiles(router, { pagination: false, banner: selectedBanner.value.id });
            }
            catch (error) {
                fileErrorMessage.value = error.toString();
            }
        };
        const deleteBannerFile = async (bannerFile) => {
            if (!confirm((0, i18n_1.trans)("delete_banner_file_confirm", "Are you sure?", "banners"))) {
                return;
            }
            errorMessage.value = "";
            try {
                await bannerStore.deleteBannerFile(router, bannerFile);
                if (selectedBanner.value === null)
                    return;
                bannerStore.resetBannerFiles();
                await bannerStore.getBannerFiles(router, { pagination: false, banner: selectedBanner.value.id });
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
        };
        function getBannerStatus(status) {
            if (!status)
                return '-';
            switch (status) {
                case BannerStatusEnum_1.BannerStatusEnum.DRAFT:
                    return (0, i18n_1.trans)('draft', 'Draft', 'banners');
                case BannerStatusEnum_1.BannerStatusEnum.WAITING:
                    return (0, i18n_1.trans)('waiting', 'Waiting', 'banners');
                case BannerStatusEnum_1.BannerStatusEnum.ACTIVE:
                    return (0, i18n_1.trans)('active', 'Active', 'banners');
                case BannerStatusEnum_1.BannerStatusEnum.EXPIRED:
                    return (0, i18n_1.trans)('expired', 'Expired', 'banners');
                default:
                    return status;
            }
        }
        const onCustomerGroupTagsChanged = (tags) => {
            bannerRequest.value.customerGroups = tags.map(tag => tag.value);
        };
        const onDepartmentTagsChanged = (tags) => {
            bannerRequest.value.departments = tags.map(tag => tag.value);
        };
        const checkImageDimensions = (file, expectedWidth, expectedHeight) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => {
                    resolve(img.width === expectedWidth && img.height === expectedHeight);
                };
                img.onerror = () => resolve(false);
                img.src = URL.createObjectURL(file);
            });
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn btn-rounded btn-primary",
                        onClick: _cache[0] || (_cache[0] = ($event) => (openCreateBannerModal()))
                    }, [
                        _hoisted_3,
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("add_banner_button", "Add Banner", "banners")), 1)
                    ])
                ]),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: listFields.value,
                    "onUpdate:fields": _cache[1] || (_cache[1] = ($event) => ((listFields).value = $event)),
                    items: (0, vue_2.unref)(bannerStore).banners,
                    striped: "",
                    condensed: "",
                    panel: "",
                    class: "mt-4",
                    isBusy: (0, vue_2.unref)(bannerStore).loading,
                    sortBy: sortBy.value,
                    "onUpdate:sortBy": _cache[2] || (_cache[2] = ($event) => ((sortBy).value = $event)),
                    sortDesc: sortDesc.value,
                    "onUpdate:sortDesc": _cache[3] || (_cache[3] = ($event) => ((sortDesc).value = $event)),
                    pagination: "",
                    currentPage: page.value,
                    "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event) => ((page).value = $event)),
                    itemsPerPage: itemsPerPage.value,
                    "onUpdate:itemsPerPage": _cache[5] || (_cache[5] = ($event) => ((itemsPerPage).value = $event)),
                    totalItems: (0, vue_2.unref)(bannerStore).totalBanners
                }, {
                    "cell-status": (0, vue_2.withCtx)(({ item: banner }) => [
                        (banner.status)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_4, (0, vue_2.toDisplayString)(getBannerStatus(banner.status)), 1))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    "cell-createdDateTime": (0, vue_2.withCtx)(({ item: banner }) => [
                        (banner.createdDatetime)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.d)(new Date(banner.createdDatetime), "iso")), 1))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    "cell-datePublish": (0, vue_2.withCtx)(({ item: banner }) => [
                        (banner.datePublish)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.d)(new Date(banner.datePublish), "iso")), 1))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    "cell-dateDePublish": (0, vue_2.withCtx)(({ item: banner }) => [
                        (banner.dateDePublish)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.d)(new Date(banner.dateDePublish), "iso")), 1))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    "cell-displayMainPageBanner": (0, vue_2.withCtx)(({ item: banner }) => [
                        (banner.displayMainPageBanner)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_8))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_9))
                    ]),
                    "cell-displaySearchPageBanner": (0, vue_2.withCtx)(({ item: banner }) => [
                        (banner.displaySearchPageBanner)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_10))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_11))
                    ]),
                    "cell-displayUniversalBanner": (0, vue_2.withCtx)(({ item: banner }) => [
                        (banner.displayUniversalBanner)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_12))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_13))
                    ]),
                    "cell-actions": (0, vue_2.withCtx)(({ item: banner }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_14, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary btn-link",
                                onClick: ($event) => (openUpdateBannerModal(banner))
                            }, [
                                _hoisted_16,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("edit", "Edit", "banners")), 1)
                            ], 8, _hoisted_15),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-danger btn-link",
                                onClick: ($event) => (deleteBanner(banner))
                            }, [
                                _hoisted_18,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "banners")), 1)
                            ], 8, _hoisted_17)
                        ])
                    ]),
                    _: 1
                }, 8, ["fields", "items", "isBusy", "sortBy", "sortDesc", "currentPage", "itemsPerPage", "totalItems"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: modalIsOpen.value,
                    title: selectedBanner.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('edit_banner_modal_title', 'Edit Banner: {banner}', 'banners', { banner: selectedBanner.value.title })
                        : (0, vue_2.unref)(i18n_1.trans)('add_banner', 'Add Banner', 'banners'),
                    onClose: _cache[30] || (_cache[30] = ($event) => (modalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (errorMessage.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                                key: 0,
                                title: (0, vue_2.unref)(i18n_1.trans)('save_error', 'Save error', 'banners'),
                                message: errorMessage.value
                            }, null, 8, ["title", "message"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_19, [
                            (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('banner_title_placeholder', 'Banner title', 'banners'),
                                    label: (0, vue_2.unref)(i18n_1.trans)('banner_title_label', 'Banner title', 'banners'),
                                    required: "",
                                    modelValue: bannerRequest.value.title,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((bannerRequest.value.title) = $event)),
                                    border: ""
                                }, null, 8, ["placeholder", "label", "modelValue"])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                (0, vue_2.createVNode)(SelectInput_vue_1.default, {
                                    disabled: !bannerRequest.value.createdUser,
                                    label: (0, vue_2.unref)(i18n_1.trans)('banner_status', 'Banner status', 'banners'),
                                    class: "!flex-row items-center !w-fit !grow",
                                    modelValue: bannerRequest.value.status,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((bannerRequest.value.status) = $event)),
                                    options: bannerStatusOptions.value
                                }, null, 8, ["disabled", "label", "modelValue", "options"])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_22, [
                            (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('start_date_placeholder', 'Start Date', 'banners'),
                                    label: (0, vue_2.unref)(i18n_1.trans)('start_date_label', 'Start Date', 'banners'),
                                    type: "date",
                                    modelValue: bannerRequest.value.datePublish,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((bannerRequest.value.datePublish) = $event)),
                                    border: ""
                                }, null, 8, ["placeholder", "label", "modelValue"])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('end_date_placeholder', 'End Date', 'banners'),
                                    label: (0, vue_2.unref)(i18n_1.trans)('end_date_label', 'End Date', 'banners'),
                                    type: "date",
                                    modelValue: bannerRequest.value.dateDePublish,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((bannerRequest.value.dateDePublish) = $event)),
                                    border: ""
                                }, null, 8, ["placeholder", "label", "modelValue"])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_25, [
                            (0, vue_2.createElementVNode)("div", _hoisted_26, [
                                (0, vue_2.createElementVNode)("div", _hoisted_27, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_groups_label", "Customer groups", "banners")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_28, " (" + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_groups_optional_note", "Setting it is optional. If you don’t set it, it will be visible to everyone.", "banners")) + ") ", 1)
                            ]),
                            (0, vue_2.createVNode)(SkuTagSearchInput_vue_1.default, {
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('customer_groups_filter_placeholder', 'Search and set customer groups to control banner visibility', 'banners'),
                                options: customerGroupOptions.value,
                                "lg-max-width": "500px",
                                "initial-tags": bannerRequest.value.customerGroups,
                                onTagsChanged: onCustomerGroupTagsChanged
                            }, null, 8, ["placeholder", "options", "initial-tags"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_29, [
                            (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                (0, vue_2.createElementVNode)("div", _hoisted_31, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("departments_label", "Departments", "banners")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_32, " (" + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("departments_optional_note", "Setting it is optional. If you don’t set it, it will be visible to everyone.", "banners")) + ") ", 1)
                            ]),
                            (0, vue_2.createVNode)(SkuTagSearchInput_vue_1.default, {
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('departments_filter_placeholder', 'Search and set departments to control banner visibility', 'banners'),
                                options: departmentOptions.value,
                                "lg-max-width": "500px",
                                "initial-tags": bannerRequest.value.departments,
                                onTagsChanged: onDepartmentTagsChanged
                            }, null, 8, ["placeholder", "options", "initial-tags"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_33, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                                label: (0, vue_2.unref)(i18n_1.trans)('display_main_page_banner', 'Display main page banner', 'banners'),
                                modelValue: bannerRequest.value.displayMainPageBanner,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((bannerRequest.value.displayMainPageBanner) = $event)),
                                class: "p-2 bg-gray justify-between w-full"
                            }, null, 8, ["label", "modelValue"]),
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                                label: (0, vue_2.unref)(i18n_1.trans)('display_search_page_banner', 'Display search page banner', 'banners'),
                                modelValue: bannerRequest.value.displaySearchPageBanner,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((bannerRequest.value.displaySearchPageBanner) = $event)),
                                class: "p-2 bg-gray justify-between w-full"
                            }, null, 8, ["label", "modelValue"]),
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                                label: (0, vue_2.unref)(i18n_1.trans)('display_universal_banner', 'Display universal banner', 'banners'),
                                modelValue: bannerRequest.value.displayUniversalBanner,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((bannerRequest.value.displayUniversalBanner) = $event)),
                                class: "p-2 bg-gray justify-between w-full"
                            }, null, 8, ["label", "modelValue"])
                        ]),
                        (selectedBanner.value != null)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_34, [
                                (0, vue_2.createElementVNode)("div", _hoisted_35, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_36, [
                                        (0, vue_2.createElementVNode)("ul", _hoisted_37, [
                                            (bannerRequest.value.displayMainPageBanner)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_38, [
                                                    (0, vue_2.createElementVNode)("a", {
                                                        class: (0, vue_2.normalizeClass)(["text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal", { 'border-b-1 border-black': openTab.value === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).MAIN_PAGE }]),
                                                        onClick: _cache[13] || (_cache[13] = ($event) => (toggleTabs((0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).MAIN_PAGE)))
                                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('main_page_banner', 'Main page banner', 'banners')), 3)
                                                ]))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (bannerRequest.value.displaySearchPageBanner)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_39, [
                                                    (0, vue_2.createElementVNode)("a", {
                                                        class: (0, vue_2.normalizeClass)(["text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal", { 'border-b-1 border-black': openTab.value === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).SEARCH_PAGE }]),
                                                        onClick: _cache[14] || (_cache[14] = ($event) => (toggleTabs((0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).SEARCH_PAGE)))
                                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('search_page_banner', 'Search page banner', 'banners')), 3)
                                                ]))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (bannerRequest.value.displayUniversalBanner)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_40, [
                                                    (0, vue_2.createElementVNode)("a", {
                                                        class: (0, vue_2.normalizeClass)(["text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal", { 'border-b-1 border-black': openTab.value === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).UNIVERSAL }]),
                                                        onClick: _cache[15] || (_cache[15] = ($event) => (toggleTabs((0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).UNIVERSAL)))
                                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('universal_banner', 'universal banner', 'banners')), 3)
                                                ]))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_41, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_42, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_43, [
                                                    (0, vue_2.createElementVNode)("div", {
                                                        class: (0, vue_2.normalizeClass)({ 'hidden': openTab.value !== (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).MAIN_PAGE, 'block': openTab.value === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).MAIN_PAGE })
                                                    }, [
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                                            placeholder: (0, vue_2.unref)(i18n_1.trans)('banner_main_page_url_placeholder', 'URL', 'banners'),
                                                            label: (0, vue_2.unref)(i18n_1.trans)('banner_main_page_url_label', 'URL', 'banners'),
                                                            modelValue: bannerRequest.value.mainPageUrl,
                                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((bannerRequest.value.mainPageUrl) = $event)),
                                                            class: "mt-4 py-4 border-t-1 border-gray",
                                                            border: ""
                                                        }, null, 8, ["placeholder", "label", "modelValue"]),
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.FileInput), {
                                                            modelValue: uploadedFile.value,
                                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((uploadedFile).value = $event)),
                                                            label: (0, vue_2.unref)(i18n_1.trans)('banner_files_deskstop', 'Image for deskstops (980x120 png/jpg/jpeg)', 'banners'),
                                                            accept: "image/png,image/jpeg"
                                                        }, {
                                                            button: (0, vue_2.withCtx)(() => [
                                                                (0, vue_2.createElementVNode)("button", {
                                                                    class: "btn btn-rounded btn-primary",
                                                                    onClick: _cache[17] || (_cache[17] = ($event) => (saveBannerFile((0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).MAIN_PAGE)))
                                                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("upload", "Upload", "banners")), 1)
                                                            ]),
                                                            _: 1
                                                        }, 8, ["modelValue", "label"]),
                                                        (fileErrorMessage.value.length && lastUploadType.value === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).MAIN_PAGE)
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_44, (0, vue_2.toDisplayString)(fileErrorMessage.value), 1))
                                                            : (0, vue_2.createCommentVNode)("", true),
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(selectedBannerFiles), (bannerFile) => {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                key: bannerFile.id,
                                                                class: "flex flex-col"
                                                            }, [
                                                                (bannerFile.type === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).MAIN_PAGE)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_45, [
                                                                        (0, vue_2.createElementVNode)("div", _hoisted_46, [
                                                                            (0, vue_2.createElementVNode)("div", null, [
                                                                                (0, vue_2.createElementVNode)("img", {
                                                                                    src: bannerFile.contentUrl,
                                                                                    alt: ""
                                                                                }, null, 8, _hoisted_47)
                                                                            ]),
                                                                            (0, vue_2.createElementVNode)("button", {
                                                                                class: "btn btn-rounded btn-danger btn-link",
                                                                                onClick: ($event) => (deleteBannerFile(bannerFile))
                                                                            }, [
                                                                                _hoisted_49,
                                                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "banner")), 1)
                                                                            ], 8, _hoisted_48)
                                                                        ])
                                                                    ]))
                                                                    : (0, vue_2.createCommentVNode)("", true)
                                                            ]));
                                                        }), 128)),
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.FileInput), {
                                                            modelValue: uploadedFile.value,
                                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((uploadedFile).value = $event)),
                                                            label: (0, vue_2.unref)(i18n_1.trans)('banner_files_mobile', 'Image for mobiles (336x280 png/jpg/jpeg)', 'banners'),
                                                            accept: "image/png,image/jpeg",
                                                            class: "py-2"
                                                        }, {
                                                            button: (0, vue_2.withCtx)(() => [
                                                                (0, vue_2.createElementVNode)("button", {
                                                                    class: "btn btn-rounded btn-primary",
                                                                    onClick: _cache[19] || (_cache[19] = ($event) => (saveBannerFile((0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).MAIN_PAGE_MOBILE)))
                                                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("upload", "Upload", "banner")), 1)
                                                            ]),
                                                            _: 1
                                                        }, 8, ["modelValue", "label"]),
                                                        (fileErrorMessage.value.length && lastUploadType.value === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).MAIN_PAGE_MOBILE)
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_50, (0, vue_2.toDisplayString)(fileErrorMessage.value), 1))
                                                            : (0, vue_2.createCommentVNode)("", true),
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(selectedBannerFiles), (bannerFile) => {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                key: bannerFile.id,
                                                                class: "flex flex-wrap"
                                                            }, [
                                                                (bannerFile.type === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).MAIN_PAGE_MOBILE)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_51, [
                                                                        (0, vue_2.createElementVNode)("div", _hoisted_52, [
                                                                            (0, vue_2.createElementVNode)("div", null, [
                                                                                (0, vue_2.createElementVNode)("img", {
                                                                                    src: bannerFile.contentUrl,
                                                                                    alt: ""
                                                                                }, null, 8, _hoisted_53)
                                                                            ]),
                                                                            (0, vue_2.createElementVNode)("button", {
                                                                                class: "btn btn-rounded btn-danger btn-link",
                                                                                onClick: ($event) => (deleteBannerFile(bannerFile))
                                                                            }, [
                                                                                _hoisted_55,
                                                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "banners")), 1)
                                                                            ], 8, _hoisted_54)
                                                                        ])
                                                                    ]))
                                                                    : (0, vue_2.createCommentVNode)("", true)
                                                            ]));
                                                        }), 128))
                                                    ], 2),
                                                    (0, vue_2.createElementVNode)("div", {
                                                        class: (0, vue_2.normalizeClass)({ 'hidden': openTab.value !== (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).SEARCH_PAGE, 'block': openTab.value === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).SEARCH_PAGE })
                                                    }, [
                                                        (0, vue_2.createElementVNode)("div", _hoisted_56, [
                                                            (0, vue_2.createElementVNode)("div", _hoisted_57, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("search_page_filters", "Search page filters", "banners")), 1)
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_58, [
                                                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(searchPages, (item, index) => {
                                                                return (0, vue_2.createElementVNode)("div", { key: index }, [
                                                                    (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                                                                        label: (0, vue_2.unref)(i18n_1.trans)('shop_' + index + '_banners', index, 'banners'),
                                                                        modelValue: searchPages[index].value,
                                                                        "onUpdate:modelValue": ($event) => ((searchPages[index].value) = $event),
                                                                        class: "p-2 bg-gray justify-between w-full"
                                                                    }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
                                                                ]);
                                                            }), 64))
                                                        ]),
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                                            placeholder: (0, vue_2.unref)(i18n_1.trans)('banner_sarch_page_url_placeholder', 'URL', 'banners'),
                                                            label: (0, vue_2.unref)(i18n_1.trans)('banner_search_page_url_label', 'URL', 'banners'),
                                                            modelValue: bannerRequest.value.searchPageUrl,
                                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((bannerRequest.value.searchPageUrl) = $event)),
                                                            class: "mt-4 py-4",
                                                            border: ""
                                                        }, null, 8, ["placeholder", "label", "modelValue"]),
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.FileInput), {
                                                            modelValue: uploadedFile.value,
                                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((uploadedFile).value = $event)),
                                                            label: (0, vue_2.unref)(i18n_1.trans)('banner_files_deskstop', 'Image for deskstops (980x120 png/jpg/jpeg)', 'banners'),
                                                            accept: "image/png,image/jpeg"
                                                        }, {
                                                            button: (0, vue_2.withCtx)(() => [
                                                                (0, vue_2.createElementVNode)("button", {
                                                                    class: "btn btn-rounded btn-primary",
                                                                    onClick: _cache[22] || (_cache[22] = ($event) => (saveBannerFile((0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).SEARCH_PAGE)))
                                                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("upload", "Upload", "banners")), 1)
                                                            ]),
                                                            _: 1
                                                        }, 8, ["modelValue", "label"]),
                                                        (fileErrorMessage.value.length && lastUploadType.value === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).SEARCH_PAGE)
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_59, (0, vue_2.toDisplayString)(fileErrorMessage.value), 1))
                                                            : (0, vue_2.createCommentVNode)("", true),
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(selectedBannerFiles), (bannerFile) => {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                key: bannerFile.id,
                                                                class: "flex flex-wrap"
                                                            }, [
                                                                (bannerFile.type === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).SEARCH_PAGE)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_60, [
                                                                        (0, vue_2.createElementVNode)("div", _hoisted_61, [
                                                                            (0, vue_2.createElementVNode)("div", null, [
                                                                                (0, vue_2.createElementVNode)("img", {
                                                                                    src: bannerFile.contentUrl,
                                                                                    alt: ""
                                                                                }, null, 8, _hoisted_62)
                                                                            ]),
                                                                            (0, vue_2.createElementVNode)("button", {
                                                                                class: "btn btn-rounded btn-danger btn-link",
                                                                                onClick: ($event) => (deleteBannerFile(bannerFile))
                                                                            }, [
                                                                                _hoisted_64,
                                                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "banners")), 1)
                                                                            ], 8, _hoisted_63)
                                                                        ])
                                                                    ]))
                                                                    : (0, vue_2.createCommentVNode)("", true)
                                                            ]));
                                                        }), 128)),
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.FileInput), {
                                                            modelValue: uploadedFile.value,
                                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((uploadedFile).value = $event)),
                                                            label: (0, vue_2.unref)(i18n_1.trans)('banner_files_mobile', 'Image for mobiles (336x280 png/jpg/jpeg)', 'banners'),
                                                            accept: "image/png,image/jpeg",
                                                            class: "py-2"
                                                        }, {
                                                            button: (0, vue_2.withCtx)(() => [
                                                                (0, vue_2.createElementVNode)("button", {
                                                                    class: "btn btn-rounded btn-primary",
                                                                    onClick: _cache[24] || (_cache[24] = ($event) => (saveBannerFile((0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).SEARCH_PAGE_MOBILE)))
                                                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("upload", "Upload", "banners")), 1)
                                                            ]),
                                                            _: 1
                                                        }, 8, ["modelValue", "label"]),
                                                        (fileErrorMessage.value.length && lastUploadType.value === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).SEARCH_PAGE_MOBILE)
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_65, (0, vue_2.toDisplayString)(fileErrorMessage.value), 1))
                                                            : (0, vue_2.createCommentVNode)("", true),
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(selectedBannerFiles), (bannerFile) => {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                key: bannerFile.id,
                                                                class: "flex flex-wrap"
                                                            }, [
                                                                (bannerFile.type === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).SEARCH_PAGE_MOBILE)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_66, [
                                                                        (0, vue_2.createElementVNode)("div", _hoisted_67, [
                                                                            (0, vue_2.createElementVNode)("div", null, [
                                                                                (0, vue_2.createElementVNode)("img", {
                                                                                    src: bannerFile.contentUrl,
                                                                                    alt: ""
                                                                                }, null, 8, _hoisted_68)
                                                                            ]),
                                                                            (0, vue_2.createElementVNode)("button", {
                                                                                class: "btn btn-rounded btn-danger btn-link",
                                                                                onClick: ($event) => (deleteBannerFile(bannerFile))
                                                                            }, [
                                                                                _hoisted_70,
                                                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "banners")), 1)
                                                                            ], 8, _hoisted_69)
                                                                        ])
                                                                    ]))
                                                                    : (0, vue_2.createCommentVNode)("", true)
                                                            ]));
                                                        }), 128))
                                                    ], 2),
                                                    (0, vue_2.createElementVNode)("div", {
                                                        class: (0, vue_2.normalizeClass)({ 'hidden': openTab.value !== (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).UNIVERSAL, 'block': openTab.value === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).UNIVERSAL })
                                                    }, [
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                                            placeholder: (0, vue_2.unref)(i18n_1.trans)('banner_universal_url_placeholder', 'URL', 'banners'),
                                                            label: (0, vue_2.unref)(i18n_1.trans)('banner_universal_url_label', 'URL', 'banners'),
                                                            modelValue: bannerRequest.value.universalUrl,
                                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((bannerRequest.value.universalUrl) = $event)),
                                                            class: "py-2",
                                                            border: ""
                                                        }, null, 8, ["placeholder", "label", "modelValue"]),
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.FileInput), {
                                                            modelValue: uploadedFile.value,
                                                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((uploadedFile).value = $event)),
                                                            label: (0, vue_2.unref)(i18n_1.trans)('banner_files_mobile', 'Image for mobiles (336x280 png/jpg/jpeg)', 'banners'),
                                                            accept: "image/png,image/jpeg"
                                                        }, {
                                                            button: (0, vue_2.withCtx)(() => [
                                                                (0, vue_2.createElementVNode)("button", {
                                                                    class: "btn btn-rounded btn-primary",
                                                                    onClick: _cache[27] || (_cache[27] = ($event) => (saveBannerFile((0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).UNIVERSAL)))
                                                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("upload", "Upload", "banners")), 1)
                                                            ]),
                                                            _: 1
                                                        }, 8, ["modelValue", "label"]),
                                                        (fileErrorMessage.value.length && lastUploadType.value === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).UNIVERSAL)
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_71, (0, vue_2.toDisplayString)(fileErrorMessage.value), 1))
                                                            : (0, vue_2.createCommentVNode)("", true),
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(selectedBannerFiles), (bannerFile) => {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                key: bannerFile.id,
                                                                class: "flex flex-wrap"
                                                            }, [
                                                                (bannerFile.type === (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).UNIVERSAL)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_72, [
                                                                        (0, vue_2.createElementVNode)("div", _hoisted_73, [
                                                                            (0, vue_2.createElementVNode)("div", null, [
                                                                                (0, vue_2.createElementVNode)("img", {
                                                                                    src: bannerFile.contentUrl,
                                                                                    alt: ""
                                                                                }, null, 8, _hoisted_74)
                                                                            ]),
                                                                            (0, vue_2.createElementVNode)("button", {
                                                                                class: "btn btn-rounded btn-danger btn-link",
                                                                                onClick: ($event) => (deleteBannerFile(bannerFile))
                                                                            }, [
                                                                                _hoisted_76,
                                                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "banners")), 1)
                                                                            ], 8, _hoisted_75)
                                                                        ])
                                                                    ]))
                                                                    : (0, vue_2.createCommentVNode)("", true)
                                                            ]));
                                                        }), 128))
                                                    ], 2)
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_77, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary",
                                onClick: _cache[29] || (_cache[29] = ($event) => (selectedBanner.value === null ? createBanner() : updateBanner()))
                            }, [
                                _hoisted_78,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("save", "Save", "banners")), 1)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
